import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import suppliersData from "../data/suppliersData";
import useScrollAnimation from "../../hooks/UseScrollAnimation";
export default function Suppliers() {
    const { t } = useTranslation();
    useScrollAnimation();
    const showData = suppliersData.map((el, index) =>
        <div key={index} className="js-scroll fade-btm w-[200px] h-[200px] bg-[rgba(100,170,178,0.2)] rounded-[8px] p-2.5">
            <img className="w-[100%] h-[100%] object-contain" src={el.image} alt="" />
        </div>
    )
    return (
        <>
            <section className="landingpages">
                <div className="container h-full flex flex-col items-center justify-center text-center">
                    <div className="btmAni1256 text-[#017E89] font-bold text-[35px] capitalize">{t("Our Suppliers")}</div>
                    <div className="btmAni2000 flex items-center gap-[5px] fonbold">
                        <Link to={"/"}>{t("Home")}</Link>
                        -
                        <span className="text-[#017E89] capitalize">{t("Our Suppliers")}</span>
                    </div>
                </div>
            </section>
            <section className="relative py-[40px]">
                <div className="container flex flex-col gap-[50px]">
                    <div className="btmAni25002 flex items-baseline gap-[7px]">
                        <img className="w-[35px] h-auto" src={require("../../assets/icons/lineTitle.svg").default} alt="" />
                        <div className="font-bold capitalize text-[25px] text-[#017e89]">{t("Our Suppliers")}</div>
                    </div>
                    <div className="flex items-center gap-[10px] flex-wrap justify-center">
                        {showData}
                    </div>
                </div>
            </section>
        </>
    );
}